import * as dayjsModule from 'dayjs'
import * as customParseFormat from 'dayjs/plugin/customParseFormat'

dayjsModule.extend(customParseFormat.default)

export const dayjs = dayjsModule.default

export function setCookie (name: string, value: string, days?: number): void {
  let expires = ''
  if (days !== undefined) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = name + '=' + (value ?? '') + expires + '; path=/'
}

export function getCookie (name: string): string | null {
  try {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') c = c.substring(1, c.length)
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
    }
    return null
  } catch (e) {
    return null
  }
}

export function removeCookie (name: string): void {
  document.cookie = name + '=; Max-Age=-99999999;'
}

export function arrayToChunks (array: any[], size: number): any[] {
  const results: any[] = []
  while (array.length > 0) {
    results.push(array.splice(0, size))
  }
  return results
}

/**
 * Склоняет названия в зависимости от количества
 * ! работает с жестким массивом типа ["год", "года", "лет"]
 * @param {*} number
 * @param {*} titles
 * @returns
 */
export function countForm (number: number, titles: string[]): string {
  return titles[
    number % 10 === 1 && number % 100 !== 11
      ? 0
      : number % 10 >= 2 &&
        number % 10 <= 4 &&
        (number % 100 < 10 || number % 100 >= 20)
        ? 1
        : 2
  ]
}

/**
 * Форматирует номер телефона
 * @param phone "74956516520"
 * @returns 8 (495) 651-65-20
 */
export function formatPhoneNumber (phone: string): string {
  const cleaned = ('' + phone).replace(/\D/g, '')
  const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})$/)
  if (match != null) {
    return `8 (${match[2]}) ${match[3]}-${match[4]}-${match[5]}`
  }
  return ''
}

export function removeHttp (url): string | null {
  if (url === null) {
    return ''
  }
  const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i)
  if (
    match != null &&
    match.length > 2 &&
    typeof match[2] === 'string' &&
    match[2].length > 0
  ) {
    return match[2]
  } else {
    return ''
  }
}

const DATE_FORMATES = [
  'DD.MM.YYYY',
  'DD.MM.YYYY HH:mm:ss',
  'DD.MM.YYYY HH:mm',
  'YYYY-MM-DD',
  'YYYY.MM.DD'
]

export function dateParse ({
  date = '',
  format = 'DD.MM.YYYY'
}: {
  date: string
  format: string
}): string {
  if (date !== '') {
    return dayjs(date, DATE_FORMATES).format(format)
  }
  return ''
}

export function getOrderNumber ({
  index,
  page,
  pageSize
}: {
  index: number
  page: number
  pageSize: number
}): number {
  const orderNumber = (page - 1) * pageSize + index + 1
  if (!Number.isNaN(orderNumber)) {
    return orderNumber
  }
  return 0
}

export function cleanValues ({
  values = {},
  keys = ['']
}: {
  values: object
  keys: string[]
}): object {
  const newVals = {}
  Object.keys(values).forEach(key => {
    if (!keys.includes(key)) {
      newVals[key] = values[key]
    }
  })
  return newVals
}

function isIpadOS (): boolean {
  return navigator.maxTouchPoints !== undefined &&
    navigator.maxTouchPoints > 2 &&
    navigator.platform.includes('MacIntel')
}

export const isMobile = {
  any: function (): boolean {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ]

    return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem)) || isIpadOS()
  }
}
